import {
  ObjectViewHTML
} from "./chunk-ZL7FWMS7.js";

// src/jsx.js
import React from "react";
var ObjectViewJSX = class extends ObjectViewHTML {
  toView(content) {
    return /* @__PURE__ */ React.createElement("div", { className: "View" }, content);
  }
  toList(items) {
    return /* @__PURE__ */ React.createElement("table", { className: "List" }, /* @__PURE__ */ React.createElement("tbody", null, items));
  }
  toListRow(key, item, rowKey) {
    return /* @__PURE__ */ React.createElement("tr", { key: rowKey, className: "ListRow" }, key, item);
  }
  toListKey(key) {
    return /* @__PURE__ */ React.createElement("td", { className: "ListKey", style: { "fontWeight": "bold", "verticalAlign": "top", "padding": "1px 10px" } }, key);
  }
  toListItem(item) {
    return /* @__PURE__ */ React.createElement("td", { className: "ListItem", style: { "verticalAlign": "top", "padding": "1px 10px" } }, item);
  }
  toTable(cols, rows) {
    return /* @__PURE__ */ React.createElement("table", { className: "Table" }, cols, rows);
  }
  toTableCols(cols) {
    return /* @__PURE__ */ React.createElement("thead", { className: "TableCols" }, /* @__PURE__ */ React.createElement("tr", null, cols));
  }
  toTableCol(col, colKey) {
    return /* @__PURE__ */ React.createElement("th", { key: colKey, className: "TableCol" }, col);
  }
  toTableRows(rows) {
    return /* @__PURE__ */ React.createElement("tbody", { className: "TableRows" }, rows);
  }
  toTableRow(values, rowKey) {
    return /* @__PURE__ */ React.createElement("tr", { key: rowKey, className: "TableRow" }, values);
  }
  toTableCell(value, col) {
    return /* @__PURE__ */ React.createElement("td", { key: col, className: "TableCell", style: { "verticalAlign": "top", "padding": "1px 10px" } }, value);
  }
  toBlank() {
    return null;
  }
  toBoolean(value) {
    return /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: value ? true : false, style: { pointerEvents: "none" }, readOnly: true });
  }
  toImg(url, value, maxHeight, maxWidth) {
    return /* @__PURE__ */ React.createElement("img", { alt: url.ref, src: url.href, title: value, style: { "max-height": maxHeight + "px", "max-width": maxWidth + "px" } });
  }
  toHref(url, content) {
    return /* @__PURE__ */ React.createElement("a", { href: url.href, target: "_blank" }, content);
  }
  toText(str) {
    return /* @__PURE__ */ React.createElement("span", null, str);
  }
  toLongText(str, limit) {
    return /* @__PURE__ */ React.createElement("span", { title: str }, str.substring(0, limit));
  }
  toOther(value) {
    return value;
  }
};
var toJSX = (any, opt) => ObjectViewJSX.generate(any, opt);
var jsx_default = toJSX;
export {
  ObjectViewJSX,
  jsx_default as default,
  toJSX
};
//# sourceMappingURL=jsx.js.map
